import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from './theme';
import AppRoutes from './routes';
import { EntityProvider } from './context/EntityContext';
import { AccessibilityWidget } from './components/AccessibilityWidget';

/**
 * Componente raiz, que aplica o tema do MUI e
 * engloba todo o app com o EntityProvider.
 */
const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CssBaseline />
        <EntityProvider>
          <AccessibilityWidget />
          <AppRoutes />
        </EntityProvider>
      </StyledThemeProvider>
    </ThemeProvider>
  );
};

export default App;
